// OVL-TUTORIAL (ux/11 §1.1): затемнение 70% везде, кроме выреза вокруг цели (+8 pt); цель — единственный
// активный элемент. Тап мимо — покачивание выреза и warning не чаще раза в 2 с. Бездействие: 5 с — пульс,
// 8 с — рука-указатель. Реплика Семёныча — над или под вырезом; в бою не в нижних 200 pt.
import { useEffect, useRef, useState } from 'preact/hooks';
import { useApp } from '../app/app.js';
import { tut } from './flow.js';
import { I } from '../assets/icons.js';
import { t as tr } from '../i18n/t.js';
import { Typed } from '../ui/text-fx.js';

interface R { x: number; y: number; w: number; h: number }

export function TutorialOverlay() {
  const app = useApp();
  const ui = tut.value;
  const [rect, setRect] = useState<R | null>(null);
  const [idle, setIdle] = useState(0);
  const [shake, setShake] = useState(false);
  const lastWarn = useRef(0);
  const target = ui?.target ?? null;
  useEffect(() => {
    if (!target) { setRect(null); return; }
    let raf = 0;
    const find = () => {
      const el = document.querySelector(`[data-tut="${target}"]`);
      if (el) {
        const b = el.getBoundingClientRect();
        setRect((r) => (r && Math.abs(r.x - b.x) < 1 && Math.abs(r.y - b.y) < 1 && Math.abs(r.w - b.width) < 1 && Math.abs(r.h - b.height) < 1 ? r : { x: b.x, y: b.y, w: b.width, h: b.height }));
      } else setRect(null);
      raf = requestAnimationFrame(find);
    };
    find();
    setIdle(0);
    const t5 = setTimeout(() => setIdle(1), 5000);
    const t8 = setTimeout(() => setIdle(2), 8000);
    return () => { cancelAnimationFrame(raf); clearTimeout(t5); clearTimeout(t8); };
  }, [target, ui?.step]);
  if (!ui || (!rect && !ui.retry && !ui.say && !ui.next)) return null;
  const pad = 8;
  const hole = rect ? { x: rect.x - pad, y: rect.y - pad, w: rect.w + pad * 2, h: rect.h + pad * 2 } : null;
  const miss = () => {
    setShake(true);
    setTimeout(() => setShake(false), 300);
    if (Date.now() - lastWarn.current > 2000) { lastWarn.current = Date.now(); app.haptic('warning'); }
  };
  const vh = innerHeight;
  const below = hole ? hole.y + hole.h + 12 : vh / 2;
  const bubbleAbove = hole ? hole.y > vh * 0.45 : false;
  const bubbleStyle = bubbleAbove ? { bottom: `${Math.max(vh - (hole?.y ?? vh) + 12, 0)}px` } : { top: `${Math.min(below, vh - 140)}px` };
  const text = ui.say ?? ui.hint;
  // Четыре заслонки вокруг выреза ловят тапы мимо, сам вырез пропускает тап к цели.
  const blockers = hole
    ? [
        { left: 0, top: 0, width: '100%', height: Math.max(0, hole.y) },
        { left: 0, top: hole.y + hole.h, width: '100%', bottom: 0 },
        { left: 0, top: hole.y, width: Math.max(0, hole.x), height: hole.h },
        { left: hole.x + hole.w, top: hole.y, right: 0, height: hole.h },
      ]
    : [{ left: 0, top: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,.7)' }];
  return (
    <div class="tut-overlay" style={{ pointerEvents: 'none' }} data-testid="OVL-TUTORIAL" data-step={ui.step}>
      {blockers.map((s, i) => <div key={i} style={{ position: 'absolute', pointerEvents: 'auto', ...s }} onClick={miss} />)}
      {hole ? <div class={`tut-hole ${idle >= 1 ? 'pulse' : ''} ${shake ? 'shake' : ''}`} style={{ left: hole.x, top: hole.y, width: hole.w, height: hole.h }} /> : null}
      {hole && idle >= 2 ? <div class="tut-hand" style={{ left: hole.x + hole.w * 0.6, top: hole.y + hole.h * 0.55 }} aria-hidden><I n="hand" size={36} /></div> : null}
      {text || ui.retry || ui.next ? (
        <div class="tut-bubble" key={text ?? ''} style={bubbleStyle} role="status" aria-live="polite">
          <div class="face" aria-hidden><I n="semenych" size={40} /></div>
          <div class="txt">
            {text ? <Typed text={text} testId="tut-say" /> : null}
            {ui.retry ? <div><button class="btn small accent" style={{ marginTop: 8 }} onClick={ui.retry}>{tr('CL-TUTORIAL-OVERLAY-01')}</button></div> : null}
            {ui.next && !ui.retry ? <div><button class="btn small accent" style={{ marginTop: 8 }} data-testid="tut-next" onClick={ui.next}>{tr('CL-TUTORIAL-NEXT')}</button></div> : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
